import {BASE_URL} from "../../settings/settings";


const URLS = {
    BASE_URL: BASE_URL,

    // auth
    login: 'auth/api-token-auth/',
    signUp: 'auth/sign-up',
    ResetPassword: 'auth/reset-password',
    ValidateOtp: 'auth/validate-otp',
    listQuestions: 'practice/list/',
    question: 'practice/question/',
    savePractice: 'practice/savePractice',
    convertSpeechToText: 'practice/convertSpeechToText',
    SetNewPassword: 'auth/set-new-password',
    GoogleAuthLoginSignUp: 'auth/google-login-signup',
    GoogleAuthOneTapLogin: 'auth/google-auth-one-tap-login',


    //utils
    UploadFile: 'auth/upload-file',


    reviews: 'reviews',

    //settings
    updateProfile: 'auth/update-profile',

    //payment related
    purchaseStatus: 'payments/status',
    getPackages: 'payments/packages-list',
    stripPublicKey: 'payments/stripe-public-key',
    paymentIntent: 'payments/payment-intent',
    CreatePaymentIntent: 'payments/create-payment-intent',


    CreateCouponPaymentIntent: 'payments/coupon-payment-intent',
    GetCouponCode: 'payments/get-coupon-data',


    // Community
    getCommunityComments: 'get-community-comment',
    addCommunityComment: 'add-community-comment',
    getCommunityStats: 'get-community-stats',

    MaterialList: "material-list",

//     Like api
    GetAllLikedComments: 'get-all-liked-comment-id',
    LikeDislikeComment: 'like-dislike-comment/',

//     Comments
    ReplyAComment: 'reply-comment',
    DeleteAComment: 'delete-comment',
    GetRepliesList: 'get-replies-list',


    //vocab
    getVocab: 'get-vocab-list',
    getOrAddOrFav: 'get-add-fav-vocab',


//     cefr
    checkCefr: 'cefr-check',

    //guide
    getGuideList: 'get-guide-list',

    //blogs
    getBlogs: 'blogs',
    blogsList: 'blogs-meta',

//     Practice
    notes: 'practice/notes',
    analysis: 'practice/analysis',
    markQuestion: 'practice/mark-question',
    UpdateQuestion: 'practice/update-question',

    // Generic Question
    genericQuestionView: 'practice/generic-question-view',
    getPracticedData: 'practice/get-practiced-data',
    addToTested: 'practice/add-to-tested',

    addComment: 'practice/add-comment',
    getComments: 'practice/get-comments',

//     Notification
    getNotifications: 'practice/notifications',

    packageInfo: 'payments/info',

    subscribeToNewsLetter: 'subscribe-to-news-letter',

}


export default URLS;
